import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import ElementUI from 'element-ui'

import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js'
import * as echarts from 'echarts'
import BaiduMap from 'vue-baidu-map'
import JsonExcel from 'vue-json-excel'
import VueAnimateOnScroll from 'vue-animate-onscroll'
import 'lib-flexible'
// 引入字体样式
import './assets/font/font01.css'
// 动画
Vue.component('downloadExcel', JsonExcel)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥
  ak: 'iuXbSx00bBLTGxkILBtIvWcKx6nwEF5p'
})
Vue.prototype.$echarts = echarts
Vue.use(ElementUI)
Vue.use(VueAnimateOnScroll)
Vue.use(VueFullPage)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
